<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents">
        대시보드
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'DashBoard',
        components: {
        }
    }
</script>
